import wrapper from 'wrapper';

const {
    vocab,
} = wrapper.getConfig();
const buttonsContainer = wrapper.select('.input-form__buttons');
const featuredTerms = Object.keys(vocab)
    .filter(key => key.indexOf('jargon-term-button-') !== -1)
    .map(key => vocab[key]);

function create({
    data,
    onButtonClick,
}) {
    buttonsContainer.innerHTML = featuredTerms.reduce((html, searchTerm) => {
        return `${html} <button value='${data.find(row => row.value === searchTerm).id}'>${searchTerm}</button>`;
    }, '');
    [].slice.call(buttonsContainer.querySelectorAll('button')).forEach(button => {
        button.addEventListener('click', (ev) => {
            clearSelection();
            ev.target.classList.add('selected');
            onButtonClick(parseInt(button.getAttribute('value'), 10));
        });
    });
}

function clearSelection() {
    [].slice.call(buttonsContainer.querySelectorAll('button')).forEach(button => {
        button.classList.remove('selected');
    });
}

export default {
    create,
    clearSelection,
};
